// src/lib/swr-cache.js — Lot AUTO-REFRESH + FLUIDITÉ (chantier « navigation
// sans re-fetch », audit perf §3 / QW6).
//
// Cache mémoire par clé, session-scoped (module singleton — survit au
// démontage/remontage des onglets, meurt au reload de la page). Pattern
// stale-while-revalidate MINIMAL : le cache ne décide RIEN tout seul — les
// consommateurs (useDailyPricing, CalendarPanel.loadResas, flags config)
// lisent l'entrée pour un rendu immédiat, puis refetchent en fond et
// remettent à jour l'entrée. Le premier rendu d'une session (cache vide)
// reste STRICTEMENT identique au comportement historique.
//
// AUCUNE lib externe (décision de lot). Pas de persistance (localStorage
// interdit ici : données métier potentiellement sensibles + fraîcheur).

const store = new Map() // key → { value, at: epoch ms }

/** Entrée brute { value, at } ou null. Ne juge pas la fraîcheur. */
export function swrGet(key) {
  return store.get(key) || null
}

/** Écrit/écrase l'entrée avec un timestamp « maintenant ». */
export function swrSet(key, value) {
  store.set(key, { value, at: Date.now() })
}

/** true si l'entrée existe ET a moins de maxAgeMs. */
export function swrIsFresh(entry, maxAgeMs) {
  if (!entry) return false
  return Date.now() - entry.at <= maxAgeMs
}

/**
 * Purge — sans argument : tout le cache (ex. logout) ; avec préfixe : les
 * clés du namespace (ex. swrClear('dp|') après invalidate() pricing).
 */
export function swrClear(prefix) {
  if (!prefix) {
    store.clear()
    return
  }
  for (const k of [...store.keys()]) {
    if (k.startsWith(prefix)) store.delete(k)
  }
}
